import { useEffect } from 'react';

import { PlanDetailsActionType } from '../../context/actions';
import { usePlanDetailsContext } from '../../context/context';
import { MapFilters } from '../../context/reducer';
import { useRetrieveActivePlanDrivers } from './useRetrieveActivePlanDrivers';

type UsePlanMapFiltersResponse = {
  mapFilters: MapFilters;
  setMapFilters: (filters: MapFilters) => void;
};

export const usePlanMapFilters = (): UsePlanMapFiltersResponse => {
  const { map: driversMap, isLoading: isDriversLoading } = useRetrieveActivePlanDrivers();

  const { planDetailsState, planDetailsDispatch } = usePlanDetailsContext();

  useEffect(() => {
    if (!isDriversLoading) {
      const newDriversSelection = { ...planDetailsState.mapFilters.drivers };

      Object.keys(planDetailsState.mapFilters.drivers)
        .filter((filterDriversKey) => filterDriversKey !== `unassigned`)
        .forEach((filterDriversKey) => {
          // Actual drivers filter contain an item that is not in the new drivers map.
          if (!driversMap[filterDriversKey]) {
            delete newDriversSelection[filterDriversKey];
          }
        });

      // Check if a new cluster has been passed as property
      Object.keys(driversMap).forEach((driversMapKey) => {
        // Clusters contain an item that is not in the new driversMap.
        if (newDriversSelection[driversMapKey] === undefined) {
          newDriversSelection[driversMapKey] = true;
        }
      });

      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_MAP_FILTERS,
        payload: {
          mapFilters: {
            ...planDetailsState.mapFilters,
            drivers: newDriversSelection,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDriversLoading, driversMap]);

  return {
    mapFilters: planDetailsState.mapFilters,
    setMapFilters: (filters: MapFilters) => {
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_MAP_FILTERS,
        payload: {
          mapFilters: filters,
        },
      });
    },
  };
};
